import { defineStore } from "pinia";
import dayjs from "dayjs";
import { api } from "@/plugins/api";

export const useApplicationStore = defineStore({
  id: "application",
  state: () => ({
    isShowPasswordChangePop: false, // 만기 패스워드 사용 변경 팝업
    tmpPwdYn: false, // 임시 패스워드 사용 여부
    popIds: [],
    userManuals: [], // 사용자 메뉴얼 리스트
  }),
  getters: {},
  actions: {
    showPasswordChangePop(isShow) {
      this.isShowPasswordChangePop = isShow;
    },
    checkPasswordChangeStatus(user) {
      if (!user.nextPwdChgDt) {
        return;
      }

      const nextchangeDate = dayjs(user.nextPwdChgDt);
      const today = dayjs();

      if (
        user.tmpPwdYn === "Y" ||
        today.format("YYYYMMDD") >= nextchangeDate.format("YYYYMMDD")
      ) {
        this.isShowPasswordChangePop = true;
        if (user.tmpPwdYn === "Y") {
          this.tmpPwdYn = true;
        }
      }
    },
    addPopId(id) {
      this.popIds.push(id);
    },
    removePopId(id) {
      this.popIds = this.popIds.filter((uuid) => uuid !== id);
    },
    async loadUserManuals(reloadYn = false) {
      if (!reloadYn && this.userManuals.length > 0) {
        return;
      }

      const URL = "/api/" + process.env.VUE_APP_API_V;
      const res = await api.get(`${URL}/utility/user-manual/manuals`);

      if (res.resultCode !== 200) {
        return;
      }

      this.userManuals = res.data;
    },
  },
});
